import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AddressResponse, Adresses, DeleteAddressResponse } from "../interfaces/addresses-user.interface";
import { BehaviorSubject, catchError, Observable, shareReplay, Subject, tap, throwError } from "rxjs";
import { environment } from "../../../../../../../environments/environment";
import { AuthService } from "../../../../../../core/service/auth.service";
import { NotificationsService } from "../../../../notifications/service/notifications.service";

@Injectable({ providedIn: 'root' })

export class ListAddressesUserService {
  private readonly apiUrl = `${environment.apiUrl}/address`;
  private addressesUser: Adresses[] = [];
  private _addresses = new BehaviorSubject<Adresses[]>([]);
  private refreshAddressesSubject = new Subject<void>();
  constructor(private http: HttpClient,
    private authService: AuthService,
    private notificationsService: NotificationsService
  ) {
    this._addresses = new BehaviorSubject<Adresses[]>([]);
  }

  getAddresses(userId: number): Observable<AddressResponse> {
    if (!this.authService.isLoggedIn()) {
      return throwError(() => new Error('No estás logueado'));
    }
    return this.http.get<AddressResponse>(`${this.apiUrl}/get`, {
      headers: {
        'Authorization': `Bearer ${this.authService.getToken()}`
      }
    }).pipe(
      tap((response) => {
        this.addressesUser = response.data;
        this._addresses.next(this.addressesUser);
      }),

    );

  }
  deleteAddress(addressId: number): Observable<DeleteAddressResponse> {
    let headers={
      Authorization: `Bearer ${this.authService.getToken()}`
    };
    let body={
      id_address: addressId
    };
    return this.http.delete<DeleteAddressResponse>(`${this.apiUrl}/delete`, { headers, body }).pipe(tap(() => {
      this.addressesUser = this.addressesUser.filter(address => address.ad_id !== addressId);
      this._addresses.next(this.addressesUser);
    },
      catchError((error) => {
        console.error('Error al eliminar la dirección:', error);
        this.notificationsService.addNotification({
            message: error.error?error.error.message:"Error al eliminar la direccion",
            type: "error",
            duration: 5000
          });
        return throwError(() => error);
        
      })));
  }
  getAddressesUser() {
    return this._addresses.asObservable();
  }
  getRefreshAddressesObservable() {
    return this.refreshAddressesSubject.asObservable();
  }

  refreshAddresses() {
    this.refreshAddressesSubject.next();
  }

}
